import { RenderLeafProps } from "slate-react";

export const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  let display = children;
  if (leaf.bold) display = <strong>{display}</strong>;
  if (leaf.italic) display = <em>{display}</em>;
  if (leaf.underline) display = <u>{display}</u>;

  return <span {...attributes}>{display}</span>;
};
